<template>
  <div class="page-not-found">

   <not-found-paragraph/>
    <about/>

  </div>
</template>

<script>
  import About from "../components/About/About";
  import NotFoundParagraph from "../components/Core/NotFoundParagraph";

  export default {
    name: "NotFound",
    components: {
      NotFoundParagraph, About
    },
  }
</script>

<style lang="scss">

</style>